<script>
import FamilySelector from '@/components/FamilySelector/FamilySelector.vue'
import WithLoader from '@/components/WithLoader'

export default WithLoader(FamilySelector, {
  events: ['change', 'input'],
  pendingProp: 'loading',
})
</script>
